<div class="row" style="margin:10px 0;" *ngIf="(loading | async) && !(service.item | isEmpty)">
  <div class="col-md-12">
    <div class="panel panel-default">
      <div class="panel-default">
        <div class="panel-heading" (click)="isCollapsed = !isCollapsed">
          <h4 class="panel-title">
            <div>
              <i *ngIf="!isCollapsed" class="pull-left fa fa-chevron-up"></i>
              <i *ngIf="isCollapsed" class="pull-left fa fa-chevron-down"></i>
              <a role="button">
                            <span *ngIf="!service.meta.verbose_name_plural">
                                {{ service.meta.verbose_name }}
                            </span>
                <span *ngIf="service.meta.verbose_name_plural">
                                {{ service.meta.verbose_name_plural }}
                            </span>
                <span *ngIf="service.meta.symbol">
                                <img *ngIf="service.meta.symbol.contentType | isImage"
                                     [src]="service.meta.symbol.url"/>
                            </span>
              </a>
            </div>
            <div *ngIf="service.meta.permissions.write && service.meta.type !== undefined" class="pull-right">
                          <span *ngFor="let button of service.meta.action_buttons" (click)="button.func(service.item)"
                                style="cursor: pointer; padding-left: 10px;">
                            <span>{{ button.label }} </span>
                            <i [ngClass]="'fa ' + button.icon + ' fa-lg'"></i>

                          </span>
              <span style="cursor: pointer; padding-left: 10px;" (click)="open(service.item, $event)">
                                <span *ngIf="service.item | isEmpty">Enable </span>
                                <span *ngIf="!(service.item | isEmpty)">Edit </span>
                                <i class="fa fa-plus-circle"></i>
                            </span>
              <span style="cursor: pointer; padding-left: 10px;"
                    *ngIf="!(service.item | isEmpty) && service.meta.print !== undefined">
                                <span>Print </span>
                                <i class="fa fa-print"></i>
                            </span>
              <span style="cursor: pointer; padding-left: 10px;" (click)="delete(service.item, $event)"
                    *ngIf="!(service.item | isEmpty)">
                                <span>Remove </span>
                                <i class="fa fa-times-circle"></i>
                            </span>
            </div>
          </h4>
        </div>
      </div>
      <div class="panel-body table-responsive" [ngbCollapse]="isCollapsed">
        <ng-content select='[name="addInfo"]'></ng-content>
        <div class="row">
          <div class="col-md-4 col-lg-3" *ngFor="let key of service.meta.display_fields; index as i;">
            <b>{{ service.meta.fields[service.meta.display_fields[i]]?.label }}: </b>
            <app-display-field [type]="service.meta.fields[service.meta.display_fields[i]]?.type"
                               [value]="service.item[service.meta.display_fields[i]]"
                               [choices]="service.meta.fields[service.meta.display_fields[i]]?.choices"></app-display-field>
          </div>

        </div>
        <br/>
        <span *ngFor="let key of service.meta.subItems">
                    <app-nested-inline id="{{key}}_inline"
                                       *ngIf="key.indexOf('attachment') < 0 && key.indexOf('payment') < 0 && service.item.globalid !== undefined"
                                       [meta]="service.meta.fields[key]" [foreignKey]="service.item.globalid"
                                       [parentItem]="service.item"></app-nested-inline>
                    <app-attachments
                        *ngIf="key.indexOf('attachment') > -1 && service.item.globalid !== undefined && !service.meta.listAttachments"
                        [type]="service.meta.fields[key].type" [meta]="service.meta.fields[key]"
                        [foreignKey]="service.item.globalid"></app-attachments>
                    <app-attachments-inline
                        *ngIf="key.indexOf('attachment') > -1 && service.item.globalid !== undefined && service.meta.listAttachments"
                        [type]="service.meta.fields[key].type" [foreignKey]="service.item.globalid"
                        [meta]="service.meta.fields[key]"
                        [useVerboseName]="service.meta.fields[key].use_verbose_name"
                        [displayFields]="service.meta.fields[key].display_fields"></app-attachments-inline>
                    <app-payments-inline *ngIf="key.indexOf('payment') > -1 && service.item.globalid !== undefined"
                                         [contentType]="service.meta.content_type"
                                         [meta]="service.meta.fields[key]"
                                         [parentItem]="service.item"></app-payments-inline>
                </span>
        <ng-content select='[name="additionalInlines"]'></ng-content>
      </div>
    </div>
  </div>
</div>
